<template>
    <div>
        <v-icon size="17">mdi-trash-can-outline</v-icon>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>
